<template>
    <div>
        <v-btn v-on:click="openRedsysPaymentModal" width="350px" color="#eee" elevation="0" height="40px">
            Pago único con tarjeta de crédito/débito
        </v-btn>

        <v-dialog v-model="dialog" max-width="600">
            <v-card>
                <v-card-title>
                    <span class="headline">Pagar con Tarjeta</span>
                </v-card-title>
                <v-card-text>
                    <p>Estás a punto de pagar con tarjeta. Para ello, serás redireccionado a Redsys.</p>
                    <p>Si estás de acuerdo, haz click en el botón "Ir a Pagar"</p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeModal">Cancelar</v-btn>
                    <v-btn :disabled="loading" color="blue darken-1" text @click="submitRedsysForm">Ir a Pagar</v-btn>
                </v-card-actions>
            </v-card>
            <form ref="redsysForm" name="redsysForm" :action="formAction" method="POST">
                <input type="hidden" name="Ds_SignatureVersion" value="HMAC_SHA256_V1" />
                <input type="hidden" name="Ds_MerchantParameters" :value="merchantParameters" />
                <input type="hidden" name="Ds_Signature" :value="signature" />
            </form>
        </v-dialog>
    </div>
</template>

<script>
import baseUrl from '../../../../../../core/constants/uri';
import commons from '../../Mixins/commons';
import Configuration from '../../../../../../core/constants/configuration';
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            dialog: false,
            merchantParameters: '',
            signature: '',
            formAction: `${Configuration.value('redsys')}`,
            loading: false,
        };
    },
    props: {
        resumen: Object
    },
    computed: {
            ...mapGetters({
                loggedUsername: 'commons/getUserName',
                user: 'commons/getUser',
            })
        },
    mixins: [commons],
    methods: {
        submitRedsysForm() {
            this.loading = true;
            // Get a reference to the form element
            this.$emit('changeStep', 'pending');
            this.$store.commit('commons/SET_SIGNED_USERDATA', true);
            const form = this.$refs.redsysForm;
            // Submit the form
            form.submit();
        },
        openRedsysPaymentModal() {
            this.loading = true;
            // Fetch the payment form HTML from the Redsys API
            const authToken = localStorage.getItem('access_token') ? JSON.parse(localStorage.getItem('access_token')) : '';
            const resumen = { total: this.resumen.total, items: this.resumen.items.subtotal.items };
            const titular = `${this.user.userData.lastname}, ${this.user.userData.name}`;
            const intentID = this.$paymentsIdToArray(resumen.items)
            fetch(`${baseUrl}/redsys/payment`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${authToken}`,
                },
                body: JSON.stringify({
                    'intent_id': intentID,
                    'merchant_titular': titular,
                    'purchase_units': {
                        'items': resumen.items.map(item => {
                            return {
                                'name': `${item.title}`,
                                'description': `${item.title}`,
                                'quantity': '1',
                                'unit_amount': {
                                    'value': `${item.monto}`
                                }
                            }
                        }),
                        'amount': {
                            'value': `${resumen.total}`
                        }
                    }
                }),
            })
                .then(res => res.json())
                .then(data => {
                    this.loading = false;
                    this.dialog = true;
                    this.merchantParameters = data.Ds_MerchantParameters;
                    this.signature = data.Ds_Signature;
                });
        },
        closeModal() {
            this.loading = false;
            this.dialog = false;
        },
    },
};
</script>
